import React, { Component } from 'react';
import { range } from 'ramda';
import { Button } from 'js/components/common/Button';
import { Icon } from 'js/components/common/Icon';
import style from './index.scss';

export class Keyboard extends Component {
    shouldComponentUpdate(nextProps) {
        return this.props.isUnlimited !== nextProps.isUnlimited;
    }

    setValue = (e) => {
        const { onInput } = this.props;
        const { id } = e.currentTarget;

        onInput(id);
    };

    render() {
        const { isUnlimited, onCancel, onSubmit, t } = this.props;
        const { setValue } = this;

        return (
            <div className={`${style.keyboard} ${style.column}`}>
                {range(0, 10).map(id =>
                    <button onClick={setValue}
                        key={id}
                        id={id}
                        type="button"
                        className={`${style.button} ${style.number}`}
                        disabled={isUnlimited}
                    >
                        {id}
                    </button>
                )}
                <button
                    type="button"
                    onClick={onCancel}
                    className={`${style.button} ${style.cancel}`}
                    disabled={isUnlimited}
                    aria-label={t('playtech.mobile.system.button.aria-label.clear')}
                >
                    <Icon type="clear" />
                </button>
                <div className={`${style.button} ${style.submit}`}>
                    <Button
                        onClick={onSubmit}
                        aria-label={t('playtech.mobile.system.button.aria-label.done')}
                    >
                        <Icon type="done" />
                    </Button>
                </div>
            </div>
        );
    }
}

export default Keyboard;
